import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import Select from "react-select";
import { toast } from "react-toastify";
import DepartmentService from "../../../../../services/Company/DepartmentService";

const AddCompanyModal = ({
	addModal,
	setAddModal,
	item,
	setShouldUpdate,
	Service,
}) => {
	const [formData, setFormData] = useState({
		legalName: "",
		civilId: "",
		authorisedSignatory: "",
		owner: "",
		address: "",
		description: "",
		licenseNumber: "",
		commercialRegistration: "",
		legalOffice: "",
		phone: "",
		establishmentDate: "",
		faxNumber: "",
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);

	useEffect(() => {
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			Service.find(item?.id).then((res) => {
				if (res?.status) {
					const response = res?.data?.data;
					setIsAdd(false);
					setFormData({
						legalName: response?.legalName,
						civilId: response?.civilId,
						authorisedSignatory: response?.authorisedSignatory,
						owner: response?.owner,
						address: response?.address,
						description: response?.description,
						licenseNumber: response?.licenseNumber,
						commercialRegistration: response?.commercialRegistration,
						legalOffice: response?.legalOffice,
						phone: response?.phone,
						faxNumber: response?.faxNumber,
						establishmentDate: response?.establishmentDate?.split("T")[0],
					});
				}
			});
		}
	}, [item]);

	const submit = (e) => {
		e.preventDefault();
		let data = {
			...formData,
		};

		setLoading(true);
		if (isAdd) {
			Service.create(data)
				?.then((res) => {
					if (res && res?.status === 201) {
						toast.success(`Company Added Successfully`);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			Service.update(item?.id, data)
				?.then((res) => {
					if (res && res?.status === 200) {
						toast.success(`Company Updated Successfully`);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Modal
			className={lang === "en" ? "en fade " : "ar fade"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#000",
										fontSize: "22px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.company}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>
						{/* Legal Name */}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.legal_name}
								type="text"
								placeholder={Translate[lang]?.legal_name}
								bsSize="lg"
								name="legalName"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.legalName}
								onChange={(e) =>
									setFormData({ ...formData, legalName: e.target.value })
								}
							/>
						</Col>
						{/* Civil Id */}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.civil_id}
								type="text"
								placeholder={Translate[lang]?.civil_id}
								bsSize="lg"
								name="civilId"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.civilId}
								onChange={(e) =>
									setFormData({ ...formData, civilId: e.target.value })
								}
							/>
						</Col>
						{/* Phone*/}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.phone}
								type="text"
								placeholder={Translate[lang]?.phone}
								bsSize="lg"
								name="phone"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.phone}
								onChange={(e) =>
									setFormData({
										...formData,
										phone: e.target.value,
									})
								}
							/>
						</Col>
						{/* Authorised Signatory */}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.authorised_signatory}
								type="text"
								placeholder={Translate[lang]?.authorised_signatory}
								bsSize="lg"
								name="authorisedSignatory"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.authorisedSignatory}
								onChange={(e) =>
									setFormData({
										...formData,
										authorisedSignatory: e.target.value,
									})
								}
							/>
						</Col>
						{/* Owner */}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.owner}
								type="text"
								placeholder={Translate[lang]?.owner}
								bsSize="lg"
								name="owner"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.owner}
								onChange={(e) =>
									setFormData({
										...formData,
										owner: e.target.value,
									})
								}
							/>
						</Col>
						{/* License Number */}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.license_number}
								type="text"
								placeholder={Translate[lang]?.license_number}
								bsSize="lg"
								name="licenseNumber"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.licenseNumber}
								onChange={(e) =>
									setFormData({
										...formData,
										licenseNumber: e.target.value,
									})
								}
							/>
						</Col>
						{/* Commercial Registration */}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.commercial_registration}
								type="text"
								placeholder={Translate[lang]?.commercial_registration}
								bsSize="lg"
								name="commercialRegistration"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.commercialRegistration}
								onChange={(e) =>
									setFormData({
										...formData,
										commercialRegistration: e.target.value,
									})
								}
							/>
						</Col>
						{/* Legal Office */}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.legal_office}
								type="text"
								placeholder={Translate[lang]?.legal_office}
								bsSize="lg"
								name="legalOffice"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.legalOffice}
								onChange={(e) =>
									setFormData({
										...formData,
										legalOffice: e.target.value,
									})
								}
							/>
						</Col>
						{/* Establishment Date */}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.establishment_date}
								type="date"
								placeholder={Translate[lang]?.establishment_date}
								bsSize="lg"
								name="establishmentDate"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.establishmentDate}
								onChange={(e) =>
									setFormData({
										...formData,
										establishmentDate: e.target.value,
									})
								}
							/>
						</Col>
						{/* Fax Number */}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.fax_number}
								type="text"
								placeholder={Translate[lang]?.fax_number}
								bsSize="lg"
								name="faxNumber"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.faxNumber}
								onChange={(e) =>
									setFormData({
										...formData,
										faxNumber: e.target.value,
									})
								}
							/>
						</Col>
						{/* Address */}
						<Col md={12}>
							<AvField
								label={Translate[lang]?.address}
								type="text"
								placeholder={Translate[lang]?.address}
								bsSize="lg"
								name="address"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.address}
								onChange={(e) =>
									setFormData({
										...formData,
										address: e.target.value,
									})
								}
							/>
						</Col>
						{/* Description */}
						<Col md={12}>
							<AvField
								label={Translate[lang]?.description}
								type="text"
								placeholder={Translate[lang]?.description}
								bsSize="lg"
								name="description"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.description}
								onChange={(e) =>
									setFormData({
										...formData,
										description: e.target.value,
									})
								}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.company}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddCompanyModal;
